
import { butter } from "~/plugins/buttercms";
import {
  invokeShopifyQuery,
  itemFilterWithGreets,
  GIFT_ADDS,
  GREET_NAME,
  GREET,
} from "@/utils/shopify";
import ProductMapMixin from "~/mixin/product-map-mixin";
import ShopifyProduct from "~/types/shopify/ShopifyProduct";
import FormatMixin from "~/mixin/format-mixin";
import ProcessLineItemsMixin from "~/mixin/process-lineitems-mixin";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
import Addon from "~/types/cms/Addon";

export default {
  name: "cal-greet-section",
  data() {
    return {
      isShowReadMore: false,
      greets: [],
      addOnsCMS: [],
      isGreetsSelected: false,
    };
  },
  props: {
    showGreets: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  mixins: [
    ProductMapMixin,
    ProcessLineItemsMixin,
    FormatMixin,
    DeliveryWeekMixin,
  ],
  async fetch() {
    try {
      await this.getAddonsContent();
      await this.getGreets();
    } catch (error) {
      console.error(error);
    }
  },
  created() {
    if (Object.keys(this.$store.state.cartItem.greet).length > 0) {
      this.isGreetsSelected = true;
    } else {
      this.isGreetsSelected = false;
    }
  },
  methods: {
    enter(el) {
      el.style.height = "0px";
      el.offsetHeight;
      el.style.height = el.scrollHeight + "px";
    },
    afterEnter(el) {
      el.style.height = "auto";
      const greetsBodyEl = document.getElementById("greet-read-more");
      if (greetsBodyEl) {
        greetsBodyEl.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    },
    leave(el) {
      el.style.height = el.scrollHeight + "px";
      el.offsetHeight;
      el.style.height = "0px";
    },
    afterLeave(el) {
      el.style.height = "0px";
    },
    onGreetSelect() {
      this.isGreetsSelected = !this.isGreetsSelected;
      let greet = this.greets[0] || {};
      greet["productType"] = GREET;
      if (!this.isGreetsSelected) {
        this.$store.dispatch("cartItem/GREET_REMOVE", greet);
      } else {
        this.$store.dispatch("cartItem/GREET_ADD", greet);
      }
    },
    handleReadMore() {
      this.isShowReadMore = !this.isShowReadMore;
    },
    getImages(title, productType, cmsData) {
      const cmsProduct = cmsData.filter((product) =>
        product.productName.includes(title)
      )[0];
      return cmsProduct ? this.isMobile ? cmsProduct.imageMobile : cmsProduct.image : "";
    },
    getUserViewName(title, productType, cmsData) {
      const cmsProduct = cmsData.filter(
        (product) => product.productName == title
      )[0];
      return cmsProduct ? cmsProduct.displayName : "";
    },
    getUserViewDescription(title, productType, cmsData) {
      const cmsProduct = cmsData.filter(
        (product) => product.productName == title
      )[0];
      return cmsProduct ? cmsProduct.shortDescription : "";
    },
    getPrice(price) {
      return this.getPriceWithLocale(price);
    },
    async processGreets(product, productType) {
      const processedGreets = product
        .filter((product) => product.title == GREET_NAME)
        .map((product) => {
          return {
            src: this.getImages(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            id: (product.productVariants[0] || {}).id,
            tags: product.tags,
            sku: (product.productVariants[0] || {}).sku,
            variant: product.productVariants[0],
            title: product.title,
            titleView: this.getUserViewName(
              product.title || "",
              productType,
              this.addOnsCMS
            ),
            priceView: Number(
              (((product || {}).priceRange || {}).maxVariantPrice || {}).amount
            ),
            priceCompare: (
              ((product || {}).variant || {}).compareAtPriceV2 || {}
            ).amount,
            price: Number(
              (((product || {}).priceRange || {}).maxVariantPrice || {}).amount
            ),
            description: product.description,
          };
        });
      return processedGreets;
    },
    getGreets() {
      return (async () => {
        const { data } = await invokeShopifyQuery(itemFilterWithGreets());
        this.greets = await this.processGreets(
          this.mapShopifyProducts(data),
          GIFT_ADDS
        );
      })();
    },
    async getAddonsContent() {
      try {
        const response = await butter(this.$config).content.retrieve(
          ["addons"],
          {
            locale: this.$i18n.locale,
            "fields.type1": "common",
          }
        );
        this.addOnsCMS = this.mapCMSAddons(response);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
